import { useRequest } from "ahooks";
import OrderDTO from "@/dto/order/OrderDTO";
import batchDownloadCustomizationImages from "../services/batchDownloadCustomizationImages";
import { Modal } from "antd";
import { getSETokenFromQn } from "@qn/services/api/getToken";
import { FD_BASE_URL } from "@/config";

const useDownloadCustomization = (getSelectedOrders: () => OrderDTO[]) => {
    const { runAsync: handleDownload, loading: downloading } = useRequest(
        async () => {
            if (import.meta.env.VITE_IS_QN) {
                Modal.info({
                    title: "提示",
                    content: "因平台限制，只能在网页版发货易操作，请在跳转后的页面下载！",
                    okText: "跳转",
                    async onOk() {
                        const token = await getSETokenFromQn();

                        const a = document.createElement("a");

                        a.href = `${FD_BASE_URL}/order/list?_token_=${token}`;

                        a.target = "_blank";

                        a.click();
                    },
                });

                return;
            }

            const orders = getSelectedOrders();

            return batchDownloadCustomizationImages(orders);
        },
        {
            manual: true,
        },
    );

    return { handleDownload, downloading };
};

export default useDownloadCustomization;
